var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7,
    cy: 17,
    r: 2,
    stroke: "#848A9B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_2",
    cx: 17,
    cy: 17,
    r: 2,
    stroke: "#848A9B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M5 17.75C5.41421 17.75 5.75 17.4142 5.75 17C5.75 16.5858 5.41421 16.25 5 16.25V17.75ZM3 17H2.25C2.25 17.4142 2.58579 17.75 3 17.75V17ZM3.75 13C3.75 12.5858 3.41421 12.25 3 12.25C2.58579 12.25 2.25 12.5858 2.25 13H3.75ZM2 4.25C1.58579 4.25 1.25 4.58579 1.25 5C1.25 5.41421 1.58579 5.75 2 5.75V4.25ZM13 5H13.75C13.75 4.58579 13.4142 4.25 13 4.25V5ZM12.25 17C12.25 17.4142 12.5858 17.75 13 17.75C13.4142 17.75 13.75 17.4142 13.75 17H12.25ZM9 16.25C8.58579 16.25 8.25 16.5858 8.25 17C8.25 17.4142 8.58579 17.75 9 17.75V16.25ZM15 17.75C15.4142 17.75 15.75 17.4142 15.75 17C15.75 16.5858 15.4142 16.25 15 16.25V17.75ZM19 16.25C18.5858 16.25 18.25 16.5858 18.25 17C18.25 17.4142 18.5858 17.75 19 17.75V16.25ZM21 17V17.75C21.4142 17.75 21.75 17.4142 21.75 17H21ZM21 11H21.75C21.75 10.5858 21.4142 10.25 21 10.25V11ZM13 10.25C12.5858 10.25 12.25 10.5858 12.25 11C12.25 11.4142 12.5858 11.75 13 11.75V10.25ZM13 5.25C12.5858 5.25 12.25 5.58579 12.25 6C12.25 6.41421 12.5858 6.75 13 6.75V5.25ZM18 6L18.6431 5.61413C18.5076 5.38822 18.2634 5.25 18 5.25V6ZM20.3569 11.3859C20.57 11.7411 21.0307 11.8562 21.3859 11.6431C21.7411 11.43 21.8562 10.9693 21.6431 10.6141L20.3569 11.3859ZM5 16.25H3V17.75H5V16.25ZM3.75 17V13H2.25V17H3.75ZM2 5.75H13V4.25H2V5.75ZM12.25 5V17H13.75V5H12.25ZM9 17.75H15V16.25H9V17.75ZM19 17.75H21V16.25H19V17.75ZM21.75 17V11H20.25V17H21.75ZM21 10.25H13V11.75H21V10.25ZM13 6.75H18V5.25H13V6.75ZM17.3569 6.38587L20.3569 11.3859L21.6431 10.6141L18.6431 5.61413L17.3569 6.38587Z",
    fill: "#848A9B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M3 9H7",
    stroke: "#848A9B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.fa430f990603a37b0654ea6eb0f9747a.svg";
export { ForwardRef as ReactComponent };